export default "__VITE_ASSET__gVp_htje__"